import React from 'react';
import { GiShoppingBag } from 'react-icons/gi'


const CartPopUp = ({ setRight, right }) => {


    return (
        <div className={`${right ? "hidden" : "hidden md:block"} `}>
            <div onClick={() => setRight(!right)} className='fixed z-20 p-2  right-0 top-1/2  shadow-lg rounded-l-md cursor-pointer md:block bg-gradient-to-t hover:from-red-800 hover:to-red-400 from-red-600 to-red-300'>
                <div className="flex flex-col items-center space-y-1">
                    <div className="flex justify-center py-1 gap-x-1 items-center ">
                        <GiShoppingBag className='font-semibold' />
                        <div className="flex flex-col leading ">
                            <span className=' font-semibold text-black text-sm'>01 item
                            </span>
                            
                        </div>
                        
                    </div>
                    <span className=' font-semibold text-black text-sm'>tk. 15
                            </span>
                    <span className='bg-white px-2 py-1 text-xs  rounded-md text-black font-semibold tracking-wider hover:bg-gray-200'>View Cart</span>
                </div>
            </div>


            {/* 
             */}

        </div>

    );
};

export default CartPopUp;